import StatusBadge from "../../Customers/StatusBadge";
import { formatDateForDisplay,formatCellValue } from "../../Utils/UtilityFunctions";

export const operatorColoumns = () => {
  const environment = (localStorage.getItem("environment"));

  const baseColumns = [
    {
      accessorKey: 'operatorId',
      header: 'Operator ID',
      size: 150,
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: 'tradingName',
      header: 'Business Name',
      size: 150,
      Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: 'domain',
      header: 'Domain',
      size: 150,
     Cell: ({ cell }) => formatCellValue(cell.getValue())
    },
    {
      accessorKey: 'startDateTime',
      header: 'Created On',
      Cell: ({ cell }) => formatDateForDisplay(cell.getValue()),
      size: 150,
    },
    {
      accessorKey: 'endDateTime',
      header: 'End Date',
      Cell: ({ cell }) => formatDateForDisplay(cell.getValue()),
      size: 150,
    },
  ];

  const statusColumn =
    environment === 'Native'
      ? {
        accessorKey: 'status',
        header: 'Status',
        Cell: ({ cell }) => {
          const value = cell.getValue();
          let displayValue;
          switch (value) {
            case 'Active':
              displayValue = 'Active';
              break;
            case 'Inactive':
              displayValue = 'Inactive';
              break;
            case 'Closed':
              displayValue = 'Closed';
              break;
            default:
              displayValue = 'Unknown';
              break;
          }
          return (
            <StatusBadge value={displayValue} />
          );
        },
      }
      : null;

  return statusColumn ? [...baseColumns, statusColumn] : baseColumns;
};